import { useDispatch } from 'react-redux';
import { setIframeVisible } from '../../actions/layout';

export default function usePay() {
  const dispatch = useDispatch();

  return (url, source = '', data = {}, visible = true) => {
    dispatch(setIframeVisible({ url, source, data, visible }));
  };
}
